import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, useTheme, tableCellClasses, styled } from '@mui/material';
import ArrowOutward from '@mui/icons-material/ArrowOutward';


import styles from './statistics.components.module.scss';
import { successRunFilter, calculateSuccessRate } from '../../utils/utils';
import Run, { StatRuns } from '../../types/run';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));


function StatTable({ allRuns, runsList, onClickHandler, filterRuns , type }: {allRuns: StatRuns[], runsList: StatRuns[], onClickHandler: any, filterRuns: Function, type: string }) {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));
  const displayRunsAndPercentage = (successfulRuns: Run[], totalRuns: Run[]) => {
    if (totalRuns.length === 0) {
      return '-';
    }
    return `${successfulRuns.length}/${totalRuns.length}(${calculateSuccessRate({ successfulRuns, totalRuns })}%)`;
  };
  return (
    <TableContainer sx={{ minWidth: isMobile ? 330 : 500 }} component={Paper}>
      <Table aria-label="simple table" size={'small'}>
        <TableHead>
          <TableRow>
            <StyledTableCell sx={{ textAlign: 'center', fontSize: 28, fontWeight: 'bold' }} colSpan={3}>{type} Stats</StyledTableCell>
          </TableRow>
        </TableHead>
        {/* <TableHead>
          <TableRow>
            <TableCell>All</TableCell>
          </TableRow>
        </TableHead> */}
        <TableBody>
        {runsList.map((runObject, index) => {
          const runObject2 = (index === 0) ? allRuns[0] : runObject;
            const successfulRuns = runObject2.runs.filter(successRunFilter);
            const rowClickFn = () => {
              if(runObject2?.runs?.length > 0) {
                filterRuns?.(runObject2.runs, runObject2.displayText);
              }
            };
            return (
              <TableRow
                key={runObject2.displayText}
                sx={{ '&:last-child td, &:last-child th': { border: 0 }, fontSize: 20 }}
              >
                <TableCell sx={{ fontSize: 20 }} scope="row" className={styles.td} onClick={rowClickFn}>
                  <span className={styles.td}>

                  {runObject2.displayText} Runs:
                  </span>
                </TableCell>
                <TableCell sx={{ fontSize: 20 }} component="td" scope="row" className={styles.td} onClick={rowClickFn}>
                <span className={styles.td}>
                  {displayRunsAndPercentage(successfulRuns, runObject2.runs)}
                </span>
                </TableCell>
                  <TableCell sx={{ fontSize: 20 }} scope="row">
                  <Button className={styles.button} variant="contained" disabled={runObject2.runs.length === 0} color="success" size="small" endIcon={<ArrowOutward />} onClick={() => onClickHandler(runObject2.runs, runObject2.displayText)}>Details</Button>
                </TableCell>
              </TableRow>
            );
            })}
        </TableBody>
      </Table>
    </TableContainer>
    // <Table className={`${styles.table} ${styles.stats}`}>
    //   <tbody>
    //     {runsList.map((runObject, index) => {
    //       const runObject2 = (index === 0) ? allRuns[0] : runObject;
    //       const successfulRuns = runObject2.runs.filter(successRunFilter);
    //       const rowClickFn = () => {
    //         if(runObject2?.runs?.length > 0) {
    //           filterRuns?.(runObject2.runs, runObject2.displayText);
    //         }
    //       };
    //       return (
    //         <tr className={styles.row} >
    //           <td className={`${styles.td} ${styles.run}`} onClick={rowClickFn}>{runObject2.displayText} Runs:</td>
    //           <td className={`${styles.td} ${styles.stat}`} onClick={rowClickFn}>{displayRunsAndPercentage(successfulRuns, runObject2.runs)}</td>
    //           {
    //             runObject2?.runs?.length > 0 ?
    //             <td className={`${styles.td} ${styles.buttons}`}>
    //               <Button className={styles.button} variant="contained" color="success" size="small" endIcon={<ArrowOutward />} onClick={() => onClickHandler(successfulRuns, runObject2.displayText)}>Clips</Button>
    //             </td>
    //             :
    //             ''
    //           }
    //         </tr>
    //       );
    //     })}
    //   </tbody>
    // </Table>
  );
}

export default StatTable;